/* eslint-disable import-extensions/file-extension-required */
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import fetchMentionsProviderDataQuery, {
	type fetchMentionsProviderDataQuery$data,
	type fetchMentionsProviderDataQuery$variables,
} from './__generated__/fetchMentionsProviderDataQuery.graphql';
import type { GraphQLError } from 'graphql';

export const preloadMentionsProvider = async (): Promise<{
	data: fetchMentionsProviderDataQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<fetchMentionsProviderDataQuery$data, fetchMentionsProviderDataQuery$variables>({
		query: fetchMentionsProviderDataQuery,
	});
